"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventBus = void 0;
var EventBus = /** @class */ (function () {
    function EventBus() {
        this.subscribers = {};
    }
    EventBus.getInstance = function () {
        if (this.instance === undefined) {
            this.instance = new EventBus();
        }
        return this.instance;
    };
    EventBus.prototype.dispatch = function (event, arg) {
        var subscriber = this.subscribers[event];
        if (subscriber === undefined) {
            return;
        }
        Object.keys(subscriber).forEach(function (key) { return subscriber[key](arg); });
    };
    EventBus.prototype.register = function (event, callback) {
        var _this = this;
        var id = this.getNextId();
        if (!this.subscribers[event])
            this.subscribers[event] = {};
        this.subscribers[event][id] = callback;
        return {
            unregister: function () {
                delete _this.subscribers[event][id];
                if (Object.keys(_this.subscribers[event]).length === 0)
                    delete _this.subscribers[event];
            },
        };
    };
    EventBus.prototype.getNextId = function () {
        return EventBus.nextId++;
    };
    EventBus.nextId = 0;
    EventBus.instance = undefined;
    return EventBus;
}());
exports.EventBus = EventBus;
//# sourceMappingURL=event-bus.js.map